import { parseHtmlToReact } from './parseHtmlToReact';
import ShortcodeProcessor from './ShortcodeProcessor';
import { ContentProps } from './types';
import { decode } from 'html-entities';

/**
 * Content
 *
 * A function that sanitizes and parses markup to react elements for JSX output
 */
export const Content = async ({
  content: rawContent,
  shortcodesMap,
  logger = { warn: console.log },
  post,
  path,
}: ContentProps): Promise<React.JSX.Element> => {
  // if we don't have content, bail early
  if (typeof rawContent !== 'string') {
    return <></>;
  }

  const decodedContent = decode(rawContent)
    .replace(/”/g, '"')
    .replace(/“/g, '"');

  const shortcodesProcessor = new ShortcodeProcessor(shortcodesMap);

  const enrichments = await shortcodesProcessor.getEnrichedDataByShortcodes(
    decodedContent,
    post?.siteSettings ?? undefined,
  );

  // Replace WordPress-style shortcodes with HTML tags
  // [some-shortcode key="2134"] -> <some-shortcode key="2134">
  const content = shortcodesProcessor.convertShortCodesToHtml(decodedContent);
  // converts content into react elements
  // <some-shortcode key="2134"> -> <SomeShortcode key="2134">
  return parseHtmlToReact({
    shortcodesMap,
    content,
    enrichments,
    post,
    path,
    logger,
  });
};
